import React, { FC, useState } from 'react';

import Menu from 'antd/es/menu';
import Link from 'next/link';

import { SFHeaderFooterCategoryFooterViewModel } from '@api/index';

import {
  MenuItem,
  MenuWrapper,
  StyledMobilMenu,
  HeaderReservationsWrapper,
  Seperator,
} from './styled';
import { IBottomHeader } from '..';
import HeaderReservations from '../HeaderReservations';

export interface IMobileCollapseMenu extends Pick<IBottomHeader, 'data'> {
  data: SFHeaderFooterCategoryFooterViewModel['header'];
  handleMenuOpen: () => void;
  isMenuOpen: boolean;
}

const MobileCollapseMenu: FC<IMobileCollapseMenu> = ({
  data,
  handleMenuOpen,
  isMenuOpen,
}) => {
  const [openKeys, setOpenKeys] = useState<string[]>([]);

  const onOpenChange = (keys: string[]) => {
    setOpenKeys(keys.length > 0 ? [keys[keys.length - 1]] : []);
  };

  return (
    <MenuWrapper isMenuOpen={isMenuOpen}>
      <StyledMobilMenu
        openKeys={openKeys}
        onOpenChange={onOpenChange}
        mode='inline'
      >
        {data?.mainMenu?.map((item) => (
          <>
            {item?.children && item?.children?.length ? (
              <Menu.SubMenu data-testid='drawer-menu-item' title={item?.name}>
                {item?.children?.map((item, i: number) => (
                  <Link
                    prefetch={false}
                    key={`${item?.href}-${i}`}
                    href={item?.href || ''}
                  >
                    <MenuItem onClick={handleMenuOpen}>
                      <Menu.Item>{item?.name}</Menu.Item>
                    </MenuItem>
                  </Link>
                ))}
              </Menu.SubMenu>
            ) : (
              <Link
                prefetch={false}
                key={item?.href || ''}
                href={item?.href || ''}
              >
                <MenuItem onClick={handleMenuOpen}>
                  <Menu.Item>{item?.name}</Menu.Item>
                </MenuItem>
              </Link>
            )}
          </>
        ))}
        <Seperator />
        <HeaderReservationsWrapper>
          <HeaderReservations />
        </HeaderReservationsWrapper>
      </StyledMobilMenu>
    </MenuWrapper>
  );
};

export default MobileCollapseMenu;
